import gql from 'graphql-tag';

const FRAGMENT_USER_ROLES = gql`
  fragment userRoleDetails on UserRole {
    id
    user_ {
      id
    }
    user {
      id
    }
    workspace {
      id
    }
    account {
      id
    }
    customer {
      id
    }
    device {
      id
      customerId
    }
    role {
      id
      name
      resourceId
    }
  }
`;

export default {
  FRAGMENT_USER_ROLES,
};
